import { Card, Modal, Form as AntdForm } from 'antd'
import styled from 'styled-components'
import Flex from 'components/Flex'
import RadioButton from 'components/Form/RadioButton'

export const StyledCard = styled(Card)`
  background: #f5f6fd;
  padding: 15px;
  width: 170px;
  border-radius: 10px;
  margin: 10px;
  border: ${props => (props?.styleProps ? '1px #3249D7 solid' : '')};
  cursor: pointer;
  .ant-card-body {
    padding: 20px;
  }
`
export const StyledCard1 = styled(Card)`
  background: #f5f6fd;
  padding: 5px;
  width: fit-content;
  border-radius: 10px;
  margin: 10px;
  border: ${props => (props?.styleProps ? '1px #3249D7 solid' : '')};
  cursor: pointer;
  .ant-card-body {
    padding: 10px;
  }
`
export const PaddingContainer = styled.div`
  padding: 10px;
`

export const OuterDiv = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 10px;
  border: 1px #e6e7ea solid;
`
export const CenterText = styled.h1`
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  color: #000000;
`

export const CardText1 = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  text-align: center;
  color: ${props => (props?.styleProps ? '#3249D7' : '#343E59')};
`
export const CardText2 = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${props => (props?.styleProps ? '#8492E7' : '#999FAC')};
  text-align: center;
`
export const CardText3 = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: #343e59;
`

export const ContentAlignCenter = styled.div`
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const BottomText = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #343e59;

  span {
    font-family: Plus Jakarta Sans;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    color: #3249d7;
    cursor: pointer;
  }
`

export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  font-size: 2em;
`
export const TopHeading = styled(Flex)`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
`
export const ChangeText = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #3249d7;
`
export const PopupModel = styled(Modal)`
  padding: 20px;
  width: 600px;
`
export const PopupText = styled.div`
  padding: 10px 0px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`
export const PopupLabel = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 15px;
  font-weight: 600;
  line-height: 19px;
  color: #4d566e;
`
export const StyledButton = styled(RadioButton)`
  margin: 10px;
  padding: 10px;
`
export const FormItem = styled(AntdForm.Item)`
  margin-bottom: 0px !important;
`
